import _ from 'lodash'
import {createReducer, createAction} from 'redux-act'
import axios from 'axios'
import qs from 'qs'
import l8n from 'l8n'

import {addSubmitForm, deleteSubmitForm, getCurrentUser, setUser} from './app'
import {baseUrl} from './../scripts/env'
import message from "antd/lib/message";

export const REDUCER = 'email_verification'
const NS = `@@${REDUCER}/`

export const sendRequest = createAction(`${NS}SEND_REQUEST`)
export const sendSuccess = createAction(`${NS}SEND_SUCCESS`)
export const sendFailure = createAction(`${NS}SEND_FAILURE`)

export const verifyRequest = createAction(`${NS}VERIFY_REQUEST`)
export const verifySuccess = createAction(`${NS}VERIFY_SUCCESS`)
export const verifyFailure = createAction(`${NS}VERIFY_FAILURE`)

export const reset = createAction(`${NS}RESET`)
export const resetSendStatus = createAction(`${NS}RESET_SEND_STATUS`)

export const openPopup = createAction(`${NS}OPEN_POPUP`)
export const closePopup = createAction(`${NS}CLOSE_POPUP`)

const initialState = {
  isPopupOpen: false,
  emailConfirmationSent: false,
}

export const sendVerificationEmail = () => async (dispatch, getState) => {
  const state = getState()
  const user = getCurrentUser(state)
  if (user.email_verified){
    return false
  }

  dispatch(sendRequest())
  const response = await axios({
    method: 'POST',
    url: `${baseUrl}/email-verification/send`
  })

  if (_.get(response, 'data.ok', false) === false) {
    dispatch(sendFailure())
    return false
  }

  dispatch(sendSuccess())
  return true
}

export const verifyCode = async (dispatch, code) => {
  dispatch(verifyRequest())
  const response = await axios({
    method: 'POST',
    url: `${baseUrl}/email-verification/verify`,
    data: qs.stringify({code}),
  })

  if (_.get(response, 'data.ok', false) === false) {
    dispatch(verifyFailure())
    message.error(l8n['emailVerify.invalidCode'])

    return false
  }

  dispatch(verifySuccess())
  message.success(l8n['emailVerify.confirmed'])
  dispatch(reset())
  dispatch(setUser({email_verified: true}))

  return true
}

export const verify = ({code}) => async (dispatch) => {
  dispatch(addSubmitForm(REDUCER))
  const status = await verifyCode(dispatch, code)
  dispatch(deleteSubmitForm(REDUCER))

  return status
}

export default createReducer(
  {
    [reset]: (state) => ({ ...state, ...initialState }),
    [resetSendStatus]: (state) => ({ ...state, emailConfirmationSent : false }),

    [sendRequest]: (state) => ({ ...state }),
    [sendSuccess]: (state) => ({ ...state, emailConfirmationSent : true }),
    [sendFailure]: (state) => ({ ...state, emailConfirmationSent : false }),

    [verifyRequest]: (state) => ({ ...state }),
    [verifySuccess]: (state) => ({ ...state }),
    [verifyFailure]: (state) => ({ ...state }),

    [openPopup]: (state) => ({ ...state, isPopupOpen : true }),
    [closePopup]: (state) => ({ ...state, isPopupOpen : false }),
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/ducks/email_verification.js